import { render, staticRenderFns } from "./SVGDocument.vue?vue&type=template&id=4c79fc5c&scoped=true&"
import script from "./SVGDocument.vue?vue&type=script&lang=js&"
export * from "./SVGDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c79fc5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c79fc5c')) {
      api.createRecord('4c79fc5c', component.options)
    } else {
      api.reload('4c79fc5c', component.options)
    }
    module.hot.accept("./SVGDocument.vue?vue&type=template&id=4c79fc5c&scoped=true&", function () {
      api.rerender('4c79fc5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGDocument.vue"
export default component.exports